module.exports = __webpack_public_path__ + "img/GAME.6902c7d8.webp";